import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "time-range-slider" };
const _hoisted_2 = { class: "time-labels" };
const _hoisted_3 = { class: "help-text" };
const _hoisted_4 = { class: "text-sm text-gray-600 text-center" };
import { computed } from 'vue';
import DualRangeSlider from './DualRangeSlider.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeRangeSlider',
    props: {
        startTime: {},
        endTime: {},
        operatingHours: {},
        orderType: {},
        constrainToOperating: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false }
    },
    emits: ["update:startTime", "update:endTime"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Zeit-Konvertierung Hilfsfunktionen
        const timeToMinutes = (time) => {
            if (!time || !time.includes(':'))
                return 0;
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        };
        const minutesToTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        };
        // Computed Properties
        const startMinutes = computed(() => timeToMinutes(props.startTime));
        const endMinutes = computed(() => timeToMinutes(props.endTime));
        // Berechne absolute Min/Max basierend auf Öffnungszeiten + 30min Puffer
        const absoluteMinMinutes = computed(() => {
            if (!props.operatingHours?.length)
                return 6 * 60; // 06:00 als Fallback
            const earliestSlot = props.operatingHours.reduce((earliest, slot) => {
                const slotStart = timeToMinutes(slot.open);
                return slotStart < timeToMinutes(earliest.open) ? slot : earliest;
            });
            const earliestMinutes = timeToMinutes(earliestSlot.open);
            return Math.max(0, earliestMinutes - 30); // Frühste Zeit - 30min
        });
        const absoluteMaxMinutes = computed(() => {
            if (!props.operatingHours?.length)
                return 22 * 60; // 22:00 als Fallback
            const latestSlot = props.operatingHours.reduce((latest, slot) => {
                const slotEnd = timeToMinutes(slot.close);
                return slotEnd > timeToMinutes(latest.close) ? slot : latest;
            });
            const latestMinutes = timeToMinutes(latestSlot.close);
            return Math.min(24 * 60, latestMinutes + 30); // Späteste Zeit + 30min
        });
        const operatingHoursInMinutes = computed(() => {
            console.log('🏢 TimeRangeSlider - Operating Hours:', {
                hasOperatingHours: !!props.operatingHours?.length,
                operatingHours: props.operatingHours,
                orderType: props.orderType
            });
            if (!props.operatingHours?.length)
                return [];
            const minutesRanges = props.operatingHours.map(slot => ({
                start: timeToMinutes(slot.open),
                end: timeToMinutes(slot.close),
                label: `Öffnungszeit: ${slot.open} - ${slot.close}`
            }));
            console.log('✅ Converted to minutes:', minutesRanges);
            return minutesRanges;
        });
        const formatTimeValue = (minutes) => {
            return minutesToTime(minutes);
        };
        // Event Handlers
        const updateStartTime = (minutes) => {
            let newTime = minutesToTime(minutes);
            // Constrain to operating hours if enabled
            if (props.constrainToOperating && props.operatingHours?.length) {
                newTime = constrainToOperatingHours(newTime);
            }
            emit('update:startTime', newTime);
        };
        const updateEndTime = (minutes) => {
            let newTime = minutesToTime(minutes);
            // Constrain to operating hours if enabled
            if (props.constrainToOperating && props.operatingHours?.length) {
                newTime = constrainToOperatingHours(newTime);
            }
            emit('update:endTime', newTime);
        };
        // Constraint Logic
        const constrainToOperatingHours = (time) => {
            if (!props.operatingHours?.length)
                return time;
            const timeMinutes = timeToMinutes(time);
            // Find the operating slot that contains this time
            for (const slot of props.operatingHours) {
                const slotStart = timeToMinutes(slot.open);
                const slotEnd = timeToMinutes(slot.close);
                // Time is within this slot - keep it
                if (timeMinutes >= slotStart && timeMinutes <= slotEnd) {
                    return time;
                }
            }
            // Time is not within any slot - find the closest valid time
            let closestTime = props.operatingHours[0].open;
            let minDistance = Math.abs(timeMinutes - timeToMinutes(closestTime));
            for (const slot of props.operatingHours) {
                const slotStart = timeToMinutes(slot.open);
                const slotEnd = timeToMinutes(slot.close);
                // Check distance to start of slot
                const distanceToStart = Math.abs(timeMinutes - slotStart);
                if (distanceToStart < minDistance) {
                    minDistance = distanceToStart;
                    closestTime = slot.open;
                }
                // Check distance to end of slot
                const distanceToEnd = Math.abs(timeMinutes - slotEnd);
                if (distanceToEnd < minDistance) {
                    minDistance = distanceToEnd;
                    closestTime = slot.close;
                }
            }
            return closestTime;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Zeit-Labels (reduziert für Mobile) "),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([6, 9, 12, 15, 18, 21], (hour) => {
                        return _createElementVNode("span", {
                            key: hour,
                            style: _normalizeStyle({ left: `${(hour / 24) * 100}%` }),
                            class: "time-label"
                        }, _toDisplayString(String(hour).padStart(2, '0')) + ":00 ", 5 /* TEXT, STYLE */);
                    }), 64 /* STABLE_FRAGMENT */))
                ]),
                _createCommentVNode(" DualRangeSlider mit Background-Ranges "),
                _createVNode(DualRangeSlider, {
                    min: startMinutes.value,
                    max: endMinutes.value,
                    "absolute-min": absoluteMinMinutes.value,
                    "absolute-max": absoluteMaxMinutes.value,
                    step: 5,
                    color: 'red',
                    "format-value": formatTimeValue,
                    "background-ranges": operatingHoursInMinutes.value,
                    "background-style": 'dashed',
                    "show-min-max": true,
                    "onUpdate:min": updateStartTime,
                    "onUpdate:max": updateEndTime
                }, null, 8 /* PROPS */, ["min", "max", "absolute-min", "absolute-max", "background-ranges"]),
                _createCommentVNode(" Hinweistext "),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1 /* CACHED */)),
                        _createTextVNode(" Wählen Sie Ihren gewünschten Zeitbereich für die " + _toDisplayString(_ctx.orderType === 'pickup' ? 'Abholung' : 'Lieferung'), 1 /* TEXT */)
                    ])
                ])
            ]));
        };
    }
});
